import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useThemeQueries } from 'views/theme';
import { useMenuPrincipal } from '../../../../../../../../services/app/providers/menu-principal-provider/menu-principal-provider';
import { EnumMenu } from "model";
import { useCadastros } from "services/app";

export const useAcoesMenu = () => {
  const history = useHistory();
  const { isMobile } = useThemeQueries();
  const { fecharMenu } = useMenuPrincipal();
  const { abrirCadastroIndicacaoRevendedor, abrirSuporteWhatsapp } = useCadastros()


  const selectAction = useCallback(
    (codigoModulo: EnumMenu, path: string) => {
      switch (codigoModulo) {
        case EnumMenu.REVENDEDORES_INDICACAO_REVENDEDORES:
          abrirCadastroIndicacaoRevendedor(undefined, '', false)
          break;
        case EnumMenu.AJUDA_SUPORTE:
          abrirSuporteWhatsapp();
          break
        default:
          history.push(path);
          break;
      }
      if (isMobile) {
        fecharMenu();
      }
    },
    [isMobile, abrirCadastroIndicacaoRevendedor, abrirSuporteWhatsapp, history, fecharMenu]
  );
  return { selectAction: selectAction };
};
